/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Birthday_Of_ElidedInputs */

const fr_calendar_birthday_of_elided = /** @type {(inputs: Calendar_Birthday_Of_ElidedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anniversaire d’`)
};

/**

* @param {Calendar_Birthday_Of_ElidedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_birthday_of_elided = /** @type {((inputs?: Calendar_Birthday_Of_ElidedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Birthday_Of_ElidedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_birthday_of_elided(inputs)
});